export const TuringTitle = "Apply to US Remote Jobs | Turing";

export default TuringTitle;